export default "__VITE_ASSET__BXvDtvqZ__"